<template>
  <div>
    <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
    <h3 v-if="label" class="text-dark font-weight-bold" v-html="label" />
    <b-dropdown ref="dropdown" class="custom-dropdown btn-block" no-caret menu-class="w-100" role="menu">
      <template #button-content>
        {{ displayText }}
        <fa-icon :icon="['far', 'angle-up']" class="mt-1 mr-2 float-right when-open" />
        <fa-icon :icon="['far', 'angle-down']" class="mt-1 mr-2 float-right when-closed" />
      </template>
      <template #default>
        <b-dropdown-item
          v-for="option in options.slice(1)"
          :key="option.value"
          :to="option.to"
          :class="option.class"
          @click.prevent.native="clickHandler(option)"
        >
          {{ option.text }}
        </b-dropdown-item>
      </template>
    </b-dropdown>
    <ValidationProvider ref="select" v-slot="{ errors }" class="w-100" :rules="rules" :name="label || ''" slim :vid="$attrs.vid">
      <input v-model="value" type="text" class="d-none" hidden />
      <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
      <h4 v-if="errors && errors[0]" class="text-danger mt-2" v-html="errors[0]" />
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: 'DpSelect',
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    rules: {
      type: [String, Object],
      required: false,
      default: null,
    },
    label: {
      type: [String, Boolean],
      required: false,
      default: false,
    },
    onHideRefocus: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    displayText() {
      return this.options?.find((option) => option.value === this.value)?.text || this.options?.[0]?.text || 'Please select';
    },
  },
  methods: {
    clickHandler(option) {
      // @link https://bootstrap-vue.org/docs/components/dropdown#closing-the-menu-via-form-interaction
      this.$refs?.dropdown?.hide?.(this.onHideRefocus);

      this.$nextTick(() => {
        this.$emit('input', option.value);
      });
    },
  },
};
</script>

<style lang="scss">
@import '@docupet/component-library/src/assets/styles/_variables';
.custom-dropdown,
.custom-dropdown.show,
.custom-dropdown:active:focus.show {
  .dropdown-toggle,
  .dropdown-toggle:active:focus {
    color: $dp-gray-7 !important;
    text-align: left;
    padding-left: 1.2rem;
    border: solid 1px $dp-gray-4;
    background-color: transparent !important;
    box-shadow: none !important;
    &[aria-expanded='false'] .when-open,
    &[aria-expanded='true'] .when-closed {
      display: none;
    }
  }
  .dropdown-menu {
    & :not(:first-child) {
      border-top: solid 1px $dp-gray-3;
    }
    margin-top: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .dropdown-item {
    &:not([href='#']) {
      color: $dp-navy !important;
      text-decoration: underline;
    }
    color: $dp-gray-7 !important;
    padding: 0.5rem 1.5rem;
    &:active {
      background-color: $dp-gray-3 !important;
    }
  }
}
.custom-dropdown.show .dropdown-toggle {
  border-color: $dp-navy !important;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
